import React from 'react';
import { Button } from '@ncoder/ui';
import { Tag } from 'lucide-react';
import { ReleaseCard, ReleaseData } from '../../atoms/version-control/ReleaseCard';

interface ReleaseListProps {
  releases: ReleaseData[];
  onDownload?: (releaseName: string) => void;
  onViewNotes?: (releaseName: string) => void;
  onCreateRelease?: () => void;
}

export const ReleaseList: React.FC<ReleaseListProps> = ({
  releases,
  onDownload,
  onViewNotes,
  onCreateRelease,
}) => {
  return (
    <div className="space-y-4">
      <div className="flex items-center justify-between">
        <h3 className="text-section-title">Releases & Tags</h3>
        {onCreateRelease && (
          <Button onClick={onCreateRelease}>
            <Tag className="h-4 w-4 mr-2" />
            Create Release
          </Button>
        )}
      </div>

      <div className="space-y-3">
        {releases.map((release) => (
          <ReleaseCard
            key={release.name}
            release={release}
            onDownload={onDownload}
            onViewNotes={onViewNotes}
          />
        ))}
      </div>
    </div>
  );
};
